import { useState } from "react";
import { Plus } from "lucide-react";
import type { FaqItem } from "@/data/content";
import { track } from "@/lib/analytics";
import { cn } from "@/lib/utils";

export function FAQAccordion({ items, showPendingNote = false }: { items: FaqItem[]; showPendingNote?: boolean }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="mt-10 border-t border-hairline">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.q} className="border-b border-hairline">
            <h3>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={`faq-panel-${i}`}
                id={`faq-button-${i}`}
                onClick={() => {
                  setOpen(isOpen ? null : i);
                  if (!isOpen) track("faq_expand", { question: item.q });
                }}
                className="flex w-full items-start justify-between gap-6 py-5 text-left"
              >
                <span className="font-[family-name:var(--font-display)] text-lg leading-snug">{item.q}</span>
                <Plus
                  aria-hidden="true"
                  className={cn(
                    "mt-1 size-5 shrink-0 text-walnut motion-craft transition-transform",
                    isOpen && "rotate-45",
                  )}
                />
              </button>
            </h3>
            <div
              id={`faq-panel-${i}`}
              role="region"
              aria-labelledby={`faq-button-${i}`}
              hidden={!isOpen}
              className="pb-6 pr-10"
            >
              <p className="text-sm leading-relaxed text-muted-foreground">{item.a}</p>
              {showPendingNote && item.pending && (
                <p className="mt-3 inline-block border-l-2 border-brass pl-3 text-xs text-muted-foreground">
                  Awaiting confirmation from Paul before this answer is finalized.
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
